export class Owner {
  ID: string;
  NAME: string;

  PERCENTAGE: number;

  HOURS_WORKED: number;
  ANNUAL_SALARY: number;
  RESPONSIBILITIES: string;
  ORDER: number;

  constructor(value: any = {}) {
    Object.assign(this, value);
  }

  static parse(json: any): Owner {
    if(json){
      let a = new Owner();

      a.ID   = json.ID;
      a.NAME = json.NAME;
      a.PERCENTAGE = json.PERCENTAGE;
      a.HOURS_WORKED = json.HOURS_WORKED;
      a.ANNUAL_SALARY = json.ANNUAL_SALARY;
      a.RESPONSIBILITIES = json.RESPONSIBILITIES;
      a.ORDER = json.ORDER;

      return a;
    }else return null;
  }

  static parseArray(json: any[]): Owner[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(Owner.parse(j));
        }
      }
    }

    return arr;
  }
}
